var BASE_URL;
var API_URL;

BASE_URL = `${process.env.REACT_APP_IMAGE_BASE_URL}/api/v1`;
API_URL = 'https://spatiogen.com/backend-spatiogen/public/api';

// Helper function to extract base particle name from ID
// Converts "water_1764141857499_11psulz32" to "water"
export const getParticleDisplayName = (particleName) => {
  if (!particleName) return '';
  return particleName.split('_')[0];
};

export { BASE_URL, API_URL };
